import { queryOptions } from '@tanstack/react-query'

import Client from '@/api/client'
import { getConfig } from '@/app/config'

import { LogItem } from '../domain/log'
import { Token } from '../domain/token'

const client = new Client(getConfig().PUBLIC_API_ENDPOINT ?? '')

type GetTokensResult = {
  items: Token[]
  pageSize: number
  page: number
  totalItems: number
}

export const getTokens = async (): Promise<Token[]> => {
  const result = await client.get<GetTokensResult>('/tokens')
  return result.items
}

export type DeleteTokenProps = {
  token: string
}

export const deleteToken = async (props: DeleteTokenProps): Promise<void> => {
  await client.delete(`/tokens/${props.token}`)
}

export type CreateTokenProps = {
  data: {
    name: string
  }
}

export type CreateTokenResult = {
  token: string
}

export const createToken = async (props: CreateTokenProps): Promise<CreateTokenResult> => {
  return await client.post<CreateTokenResult>('/tokens', props.data)
}

export const tokensQueryOptions = () =>
  queryOptions({
    queryKey: ['tokens'],
    queryFn: getTokens,
  })

export type GetTokenLogsProps = {
  tokenId: string
}

type GetTokenLogsResult = {
  items: LogItem[]
  totalItems: number
  total: number
  pageSize: number
  page: number
}

export const getTokenLogs = async (props: GetTokenLogsProps): Promise<LogItem[]> => {
  const result = await client.get<GetTokenLogsResult>(`/tokens/${props.tokenId}/logs`)
  return result.items
}

export const tokenLogQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ['token-logs', id],
    queryFn: () =>
      getTokenLogs({
        tokenId: id,
      }),
  })
